<template>
<div>
    <v-toolbar color="#eee" app fixed class="elevation-0">
        <v-badge color="primary" overlap v-if="user">
            <v-icon
            slot="badge"
            dark
            small
            >menu</v-icon>
            <v-btn flat icon dark class="ma-0" @click.stop="menu = !menu">
            <v-avatar
                color="grey"
                size="30">
                <img v-if="user.image" :src="user.image" alt="trevor">
                <v-icon dark v-else>face</v-icon>
            </v-avatar>
            </v-btn>
        </v-badge>
        <v-spacer></v-spacer>
        <v-tooltip left v-if="frentistaSelecionado">
            <template v-slot:activator="{ on }">
            <v-chip
                v-if="frentista && posto"
                color="primary"
                dark
                v-on="on"
            >
                <v-avatar class="ma-0 pa-0">
                <img
                    v-if="posto.url_logo"
                    :src="posto.url_logo"
                    alt="trevor"
                />
                <v-icon v-else>local_gas_station</v-icon>
                </v-avatar>
                {{ posto.nome_fantasia }}
            </v-chip>
            <v-chip
                v-else-if="frentista && empresa"
                color="primary"
                dark
                v-on="on"
            >
                <v-avatar class="ma-0 pa-0">
                <img
                    v-if="empresa.url_logo"
                    :src="empresa.url_logo"
                    alt="trevor"
                />
                <v-icon v-else>mdi-domain</v-icon>
                </v-avatar>
                {{ empresa.nome_fantasia }}
            </v-chip>
            </template>
            <span>Empresa logada</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip left v-if="frentistaSelecionado && user">
            <template v-slot:activator="{ on }">
            <v-chip
                color="primary"
                dark
                class="ml-2"
                @click="dialogSelecionar = true"
                v-on="on"
            >
                <v-avatar class="ma-0 pa-0">
                <v-icon>face</v-icon>
                </v-avatar>
                {{ frentistaSelecionado.nome }} - {{ frentistaSelecionado.matricula }}
            </v-chip>
            </template>
            <span>Clique para mudar {{ posto ? 'frentista' : 'funcionário' }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
    </v-toolbar>
    <v-navigation-drawer
        v-model="menu"
        v-if="frentista && menu"
        fixed
        app
        left
        class="primary"
        dark
    >
    <v-layout column fill-height>
        <v-list two-line>
        <v-list-tile class="pt-5 pb-3" color="white">
        <v-layout column>
            <img
            :src="require('@/assets/logomarcadark.png')" style="width: 40px"
            />
            <span class="caption">{{user ? user.email : ''}}</span>
        </v-layout>
        <v-spacer/>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn flat icon @click="sair" v-on="on">
                <v-icon>exit_to_app</v-icon>
            </v-btn>
            </template>
            <span>Sair</span>
        </v-tooltip>
        </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <div class="scroll-y" style="max-height: calc(100% - 130px)">
            <v-list dense>
            <template v-for="(item, index) in menu_itens">
            <v-list-tile :key="index" ripple @click="item.funcao" class="pa-1">
                <v-list-tile-action>
                <v-icon
                    size="32"
                >
                    {{ item.icon }}
                </v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                <v-list-tile-title style="font-size: 1.2em; font-weight: 600;">
                    {{ item.text.toUpperCase() }}
                </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            </template>
        </v-list>
        </div>
    </v-layout>
    </v-navigation-drawer>
    <v-dialog
        v-if="dialogSelecionar"
        v-model="dialogSelecionar"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <selecionar-frentista
            @fechar="dialogSelecionar = false"
            :frentista="frentista"
        />
    </v-dialog>
</div>
</template>

<script>
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'
export default {
  props: ['menu_itens'],
  components: {
    SelecionarFrentista
  },
  data () {
    return {
      menu: false,
      dialogSelecionar: false,
      largura_tela: 0
    }
  },
  computed: {
    tela () {
      return Number(window.innerWidth)
    },
    user () {
      return this.$store.getters.user
    },
    frentista () {
      return this.$store.getters.frentista
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  created () {
    this.largura_tela = this.tela
    if (this.largura_tela >= 1264) {
      this.menu = true
    }
  },
  methods: {
    sair () {
      this.$store.dispatch('signUserOut')
    }
  }
}
</script>
